import type { GapReviewExecutionSummary } from '@momentum/types';

/**
 * Which run the surface has loaded, from the three things that can say so.
 *
 * A rule rather than an inline expression because it decides the one fetch that
 * costs anything here — the selected run's drafts — and it has to give the same
 * answer on all four views under the layout.
 */

export interface SelectedRunSources {
  /** The `executionId` route param, present only on the run-audit route. */
  auditedExecutionId: string | undefined;
  /** The layout's `execution` search param, inherited by every view below it. */
  searchExecutionId: string | undefined;
  /** The runs, newest first — the order the API returns them in. */
  executions: GapReviewExecutionSummary[] | undefined;
}

/**
 * The audited run wins outright: auditing one run while the queue behind it
 * holds another's gaps would make the two halves of the screen disagree. Failing
 * that the URL decides, and failing that the most recent run — the work someone
 * opening this tool almost always means. Undefined only when a company has never
 * run the pipeline, or before the runs have arrived.
 */
export function resolveSelectedRun({
  auditedExecutionId,
  searchExecutionId,
  executions,
}: SelectedRunSources): string | undefined {
  return (
    auditedExecutionId ?? searchExecutionId ?? executions?.at(0)?.executionId
  );
}
